<template>
  <el-form
    :model="dynamicValidateForm.database"
    ref="dynamicValidateForm"
    :rules="rules"
  >
    <el-form-item
      v-for="(item, index) in dynamicValidateForm.databaseTemplate"
      :key="`database${index}`"
      :label="`${item.name}：`"
      :prop="item.key"
    >
      <el-input
        v-if="item.type === 'text'"
        :type="item.type"
        :placeholder="item.placeholder || '请输入内容'"
        v-model.trim="dynamicValidateForm.database[item.key]"
        :maxlength="item.maxLength"
        :disabled="item.disabled ? true : false"
      />
      <el-input
        v-else-if="item.type === 'password'"
        placeholder="请输入密码"
        v-model.trim="dynamicValidateForm.database[item.key]"
        show-password
        auto-complete="new-password"
      />
      <el-select
        v-else
        v-model="dynamicValidateForm.database[item.key]"
        placeholder="请选择"
        popper-class="dialog-select"
      >
        <el-option
          v-for="(optionsItem, optionsIndex) in item.options"
          :key="`option${optionsIndex}`"
          :label="optionsItem.label"
          :value="optionsItem.value"
        />
      </el-select>
    </el-form-item>
    <el-form-item
      class="custom-field"
      v-for="(item, index) in customField"
      label="拓展字段："
      :key="`customField${index}`"
      :prop="item.key"
    >
      <el-input
        class="custom-key"
        v-model="item.key"
      /><span
        class="custom-equal"
      >=</span><el-input
        class="custom-value"
        v-model="item.value"
      />
      <i
        class="custom-add"
        v-if="index === 0"
        @click="addCustomField"
      >+</i>
      <i
        class="custom-delete"
        @click.prevent="removeCustomField(item)"
      >-</i>
    </el-form-item>
  </el-form>
</template>

<script>
import APIS from '@apis/common.js'
export default {
  name: 'ConfigDatabase',
  computed: {
    dynamicValidateForm() {
      return {
        database: this.selectDatabase,
        databaseTemplate: this.selectDatabaseTemplate,
        customField: this.customField
      }
    }
  },
  props: {
    setInfo: {
      type: Object,
      default: () => {}
    },
    database: {
      type: Object,
      default: () => {}
    },
    encodingList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      configInfo: [],
      selectDatabaseTemplate: [],
      selectDatabase: {},
      rules: {
        kind: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        type: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        name: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        ip: [{ required: true, message: '请输入内容', trigger: 'blur' }]
      },
      customField: [{ key: '', value: '' }]
    }
  },
  methods: {
    async getDrivers(typeId, index) {
      let { status, data } = await APIS.getDrivers({
        data: { databaseId: typeId }
      })
      if (status === 0 && data && data.length !== 0) {
        this.selectDatabaseTemplate[index].options = data.map(item => {
          return {
            label: item.code,
            value: item.id
          }
        })
      } else {
        this.selectDatabaseTemplate[index].options = []
      }
    },
    initData(typeId) {
      this.resetDialog()
      this.$nextTick(() => {
        let key = this.database[this.setInfo.type]
          ? this.setInfo.type
          : this.setInfo.parentCode
        this.selectDatabaseTemplate = [...this.database[key].templateInfo]
        this.selectDatabase = Object.assign({}, this.database[key].data, {
          kind: this.setInfo.kind,
          type: this.setInfo.type,
          kindId: this.setInfo.kindId,
          typeId: this.setInfo.typeId
        })
        this.addOptions(typeId)
      })
    },
    submitForm(isConfig = false) {
      this.$refs['dynamicValidateForm'].validate(valid => {
        if (valid) {
          let params = {
            ...this.dynamicValidateForm.database,
            properties:
              this.dynamicValidateForm.customField.length === 1 &&
              (this.dynamicValidateForm.customField.key === '' ||
                this.dynamicValidateForm.customField.value === '')
                ? undefined
                : JSON.stringify(this.dynamicValidateForm.customField)
          }
          this.$emit('saveInfo', { params: params, isConfig: isConfig })
        }
      })
    },
    removeCustomField(item) {
      var index = this.customField.indexOf(item)
      if (index !== -1 && this.customField.length > 1) {
        this.customField.splice(index, 1)
      }
    },
    addCustomField() {
      this.customField.push({
        value: '',
        key: ''
      })
    },
    editData(obj) {
      this.resetDialog()
      this.$nextTick(() => {
        this.selectDatabaseTemplate = [...this.database[obj.type].templateInfo]
        this.selectDatabase = Object.assign({}, obj)
        this.addOptions(obj.typeId)
        this.customField = Object.assign([], JSON.parse(obj.properties))
      })
    },
    resetDialog() {
      this.customField = [{ key: '', value: '' }]
      this.$refs['dynamicValidateForm'].resetFields()
    },
    addOptions(typeId) {
      this.selectDatabaseTemplate.forEach((item, index) => {
        if (item.key === 'encodingId') {
          item.options = this.encodingList.map(item => {
            return {
              label: item.code,
              value: item.id
            }
          })
        } else if (item.key === 'driverId') {
          this.getDrivers(typeId, index)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  width: auto;
  margin-top: 25px;
  /deep/ &-item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    height: 25px;
    padding-right: 100px;
    &__label {
      width: 150px;
      flex-shrink: 0;
      font-size: 13px;
    }
    &__content {
      flex: 1;
      line-height: 25px;
      .el-select {
        width: 100%;
      }
      .el-input .el-icon-view {
        display: none;
      }
      .el-input {
        height: 25px;
        &__inner {
          width: 100%;
          height: 100%;
          line-height: 25px;
          background: #ffffff;
          border: 1px solid #d4d4d4;
          border-radius: 3px;
          font-family: "founder_youhei_508R";
        }
      }
      input[type="password"] {
        font-family: auto;
      }
    }
    &.custom-field {
      .el-form-item__label{
        &::before{
          display:none;
        }
      }
      .el-form-item__content {
        display: flex;
        .custom-key {
          width: 170px;
        }
        .custom-equal {
          padding: 0 5px;
          font-weight: 600;
        }
        .custom-value {
          width: 420px;
        }
        i {
          text-align: center;
          width: 25px;
          height: 25px;
          color: #454647;
          font-weight: 600;
          font-style: normal;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
